import React from 'react';
import PropTypes from 'prop-types';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import style from './style.css';
import { Formik, Form, Field, CccisdInput, CccisdSelect } from 'cccisd-formik';
import _get from 'lodash/get';

const Boilerplate = window.cccisd.boilerplate;

export const gradeOptions = [
    { value: '', label: '' },
    { value: 'PK', label: 'Pre-K' },
    { value: 'K', label: 'K' },
    ...Array.from({ length: 12 }, (v, i) => ({ value: `${i + 1}`, label: `${i + 1}` })),
];

const EditStudentForm = ({ row, closeModal, loadData, schoolList }) => {
    const renderFields = () => {
        const school = (
            <>
                <label className={style.required}>
                    <b>School:</b>
                </label>
                <Field
                    name="group"
                    className={style.required}
                    component={CccisdSelect}
                    options={schoolList.map(s => {
                        return {
                            value: s.groupId,
                            label: s.label,
                        };
                    })}
                />
            </>
        );

        const firstName = (
            <>
                <label className={style.required}>
                    <b>First Name:</b>
                </label>
                <Field name="firstName" component={CccisdInput} />
            </>
        );
        const lastName = (
            <>
                <label className={style.required}>
                    <b>Last Name:</b>
                </label>
                <Field name="lastName" component={CccisdInput} />
            </>
        );
        const email = (
            <>
                <label>
                    <b>Email:</b>
                </label>
                <Field name="email" component={CccisdInput} />
            </>
        );
        const studentId = (
            <>
                <label>
                    <b>Student ID:</b>
                </label>
                <Field name="studentId" component={CccisdInput} />
            </>
        );
        const grade = (
            <>
                <label className={style.required}>
                    <b>Grade:</b>
                </label>
                <Field name="grade" component={CccisdSelect} options={gradeOptions} />
            </>
        );
        if (row['fields.centerventionId']) {
            return [email];
        }
        return [school, firstName, lastName, email, studentId, grade];
    };

    return (
        <Formik
            initialValues={{
                group: row['pawn.groupId'],
                firstName: row['fields.firstName'],
                lastName: row['fields.lastName'],
                studentId: row['fields.studentId'],
                email: row['fields.email'],
                grade: row['fields.grade'],
            }}
            validate={values => {
                const errors = {};

                if (!('group' in values) || !values.group) {
                    errors.group = 'School is required';
                }
                if (!('firstName' in values) || !values.firstName) {
                    errors.firstName = 'First Name is required';
                }
                if (!('lastName' in values) || !values.lastName) {
                    errors.lastName = 'Last Name is required';
                }
                if (!('grade' in values) || !values.grade) {
                    errors.grade = 'Grade is required';
                }

                return errors;
            }}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={async values => {
                let updatedValues = { ...values };
                updatedValues.role = row['pawn.role'];
                updatedValues.pawnHash = row['pawn.pawnHash'];

                const pawnUpdateResponse = await axios.put(
                    Boilerplate.route('api.nexus.pawn.update', {
                        pawn: row['pawn.pawnId'],
                    }),
                    updatedValues
                );

                let ok = pawnUpdateResponse.status === 200 && _get(pawnUpdateResponse, 'data.status', '') === 'success';

                if (ok) {
                    notification({
                        message: 'Student was updated!',
                    });
                } else {
                    notification({
                        message: 'Error updating student',
                        type: 'danger',
                    });
                }

                closeModal();
                loadData();
            }}
            render={({ values, errors }) => {
                return (
                    <Form>
                        <div style={row['fields.centerventionId'] ? {} : { minHeight: '270px' }}>{renderFields()}</div>
                        <div className={style.submit_button_container}>
                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </div>
                    </Form>
                );
            }}
        />
    );
};

EditStudentForm.propTypes = {
    row: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    loadData: PropTypes.func.isRequired,
    schoolList: PropTypes.array.isRequired,
};

EditStudentForm.defaultProps = {};

export default EditStudentForm;
